"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWrapperForGoverning = void 0;
var BaseWrapper_1 = require("./BaseWrapper");
/** @internal */
var BaseWrapperForGoverning = /** @class */ (function (_super) {
    __extends(BaseWrapperForGoverning, _super);
    function BaseWrapperForGoverning(connection, contract, contracts) {
        var _this = _super.call(this, connection, contract) || this;
        _this.connection = connection;
        _this.contract = contract;
        _this.contracts = contracts;
        return _this;
    }
    return BaseWrapperForGoverning;
}(BaseWrapper_1.BaseWrapper));
exports.BaseWrapperForGoverning = BaseWrapperForGoverning;
//# sourceMappingURL=BaseWrapperForGoverning.js.map